<div class="h-full" style="display: grid;">
    <div
        class="w-full flex flex-column justify-content-between align-items-center surface-0 shadow-4 p-3 border-round avatarGrid_avatarPos"
        [ngClass]="{ 'surface-0': !!user?.active, 'surface-100': !user?.active }">
        <app-avatar
            size="xlarge"
            [src]="user?.image"
            [initials]="user | personInitials"
            [onlineStatus]="user?.active ? OnlineStatusEnum.Online : OnlineStatusEnum.Deactivated"
        ></app-avatar>
        <app-user-main-info
            [user]="user"
        ></app-user-main-info>
        <!--        TODO: temporary hidden as requirement -->
        <!--        <div class="w-full flex flex-row justify-content-center pt-3 my-2 border-top-1 border-300">-->
        <!--            <a *ngIf="user?.active && user?.email" href="{{ 'mailto:' + user?.email }}">-->
        <!--                <p-button-->
        <!--                    icon="pi pi-envelope"-->
        <!--                    class="mx-auto"-->
        <!--                    styleClass="{{ 'w-3rem h-3rem p-button-icon' + (!user?.active ? ' p-button-secondary' : '') }}"-->
        <!--                >-->
        <!--                </p-button>-->
        <!--            </a>-->
        <!--            <p-button-->
        <!--                *ngIf="!user?.active || !user?.email"-->
        <!--                icon="pi pi-envelope"-->
        <!--                class="mx-auto"-->
        <!--                styleClass="{{ 'w-3rem h-3rem p-button-icon' + (!user?.active ? ' p-button-secondary' : '') }}"-->
        <!--                [disabled]="true"-->
        <!--            >-->
        <!--            </p-button>-->

        <!--            <p-button-->
        <!--                icon="pi pi-comment"-->
        <!--                tooltipPosition="top"-->
        <!--                pTooltip="{{ 'database.usersPage.usersTile.chatButtonTooltip' | translate }}"-->
        <!--                class="mx-auto"-->
        <!--                styleClass="{{ 'w-3rem h-3rem p-button-icon' + (!user?.active ? ' p-button-secondary' : '') }}"-->
        <!--                (click)="openChat()"-->
        <!--                [disabled]="true"-->
        <!--            ></p-button>-->

        <!--            <p-button-->
        <!--                icon="pi pi-send"-->
        <!--                tooltipPosition="top"-->
        <!--                pTooltip="{{ 'database.usersPage.usersTile.notificationButtonTooltip' | translate }}"-->
        <!--                class="mx-auto"-->
        <!--                styleClass="{{ 'w-3rem h-3rem p-button-icon' + (!user?.active ? ' p-button-secondary' : '') }}"-->
        <!--                (click)="sendPushNotification()"-->
        <!--                [disabled]="true"-->
        <!--            ></p-button>-->

        <!--            <a *ngIf="user?.active && (user?.mobile || user?.phone)" href="{{ 'tel:' + user?.mobile || user?.phone }}">-->
        <!--                <p-button-->
        <!--                    icon="pi pi-phone"-->
        <!--                    class="mx-auto"-->
        <!--                    styleClass="{{ 'w-3rem h-3rem p-button-icon' + (!user?.active ? ' p-button-secondary' : '') }}"-->
        <!--                >-->
        <!--                </p-button>-->
        <!--            </a>-->
        <!--            <p-button-->
        <!--                *ngIf="!user?.active || !(user?.mobile || user?.phone)"-->
        <!--                icon="pi pi-phone"-->
        <!--                class="mx-auto"-->
        <!--                styleClass="{{ 'w-3rem h-3rem p-button-icon' + (!user?.active ? ' p-button-secondary' : '') }}"-->
        <!--                [disabled]="true"-->
        <!--            >-->
        <!--            </p-button>-->

        <!--            <p-button-->
        <!--                icon="pi pi-video"-->
        <!--                tooltipPosition="top"-->
        <!--                pTooltip="{{ 'database.usersPage.usersTile.videoChatButtonTooltip' | translate }}"-->
        <!--                class="mx-auto"-->
        <!--                styleClass="{{ 'w-3rem h-3rem p-button-icon' + (!user?.active ? ' p-button-secondary' : '') }}"-->
        <!--                [disabled]="true"-->
        <!--            ></p-button>-->
        <!--        </div>-->
        <!--        <span-->
        <!--            class="w-full text-xs text-500 text-left my-2">{{ 'database.usersPage.usersTile.reportedWorkBarLabel' | translate }}</span>-->
        <!--        <p-progressBar-->
        <!--            [value]="user?.active ? 50 : 0"-->
        <!--            [showValue]="false"-->
        <!--            class="w-full"-->
        <!--            [style]="{height: '0.5rem'}"-->
        <!--        ></p-progressBar>-->
    </div>
    <div class="avatarGrid_editPos m-2">
        <i
            class="pi cursor-pointer"
            [class.pi-user]="!user?.canEdit"
            [class.pi-user-edit]="user?.canEdit"
            style="font-size: 2rem;"
            (click)="openDetail()"
        ></i>
    </div>
</div>
